@if (toasts().length) {
  <div id="toasts" role="status" aria-live="polite" aria-atomic="false">
    @for (t of toasts(); track t.id) {
      <div
        class="toast"
        [class.red]="tone(t) === 'red'"
        [class.green]="tone(t) === 'green'"
        [class.leaving]="t.leaving"
        [attr.data-kind]="t.kind"
      >
        <div class="tt">{{ t.title }}</div>
        <div class="tm">{{ t.message }}</div>
        <button type="button" class="toast-x" aria-label="Dismiss" (click)="dismiss(t.id)">
          &times;
        </button>
      </div>
    }
  </div>
}
